
import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch, Prop } from 'vue-property-decorator';

@Component
export default class NavBread extends Vue {
    @Prop({default: []}) navData: any;
}
